exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-account-nav {\n  font-size: 14px;\n  margin-top: -20px;\n  margin-bottom: -35px;\n}\n\n.link-account-nav a {\n  cursor: pointer;\n  color: #e7e7e7;\n  text-decoration: none;\n}\n\n\n.box_resgister {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: space-arounds;\n      justify-content: space-arounds;\n  margin-top: 20px;\n}\n\n.btn-back__login {\n  width: 15%;\n}\n\n.btn-resigter {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-right: 70px;\n}\n\n.label-input {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0 3px;\n  margin-bottom: 0;\n}\n\n.text-require {\n  color: #f52606;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/auth/register.css
// module id = ../../../../../src/app/pages/admin/auth/register.css
// module chunks = 3